import React from 'react'
import { ListMobile, Map } from '../../../assets/icons'
import { MobileToggle, ToggleButton } from './styled'

const MobileViewToggle = ({ showMap, onToggle, overlay }) => (
	<MobileToggle $overlay={overlay}>
		{showMap ? (
			<ToggleButton onClick={() => onToggle(false)}>
				<ListMobile />
				Lista
			</ToggleButton>
		) : (
			<ToggleButton onClick={() => onToggle(true)}>
				<Map />
				Mapa
			</ToggleButton>
		)}
	</MobileToggle>
)

export default MobileViewToggle
